<template>
  <p v-if="variant === ''" :class="className"><slot></slot></p>

  <strong v-if="variant === 'strong'"><slot></slot></strong>

  <small v-if="variant === 'sm'" :class="className"><slot></slot></small>

  <div v-if="variant === 'xs'" :class="`txt-xs ${className}`">
    <slot></slot>
  </div>

  <ul v-if="notes.length" class="list-unstyled notes">
    <li :key="note" v-for="note in notes">{{ note }}</li>
  </ul>
</template>

<script>
export default {
  name: "Text",
  props: {
    // variant: [ default, strong, sm, xs ]
    variant: {
      type: String,
      default: "",
    },
    notes: {
      type: Array,
      default: () => [],
    },
    // color: [ red, gray ]
    color: {
      type: String,
      default: "",
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      className: "",
      colors: {
        red: "red",
        gray: "gray",
      },
    };
  },
  created() {
    this.className = this.colors.hasOwnProperty(this.color)
      ? this.colors[this.color]
      : "";

    if (this.inline) {
      this.className += " d-inline-block";
    }
  },
};
</script>
